export default __webpack_public_path__ + "static/media/Find My Way.d6e873cb.svg";